<template>
  <keep-alive>
    <div v-if="$route.name != 'Home'" class='menu' :class='{center: $route.name === "IssueInner" || $route.name === "Issue" || $route.name === "Colophon", menu_issue: $route.name === "Issue", menu_show: $route.name != "Home"}'>
      <span>Go to: </span>
      <router-link to="/"><span>Index</span></router-link>
      <router-link v-if="$route.name != 'Home' && $route.name != 'Colophon'" :class="active('colophon')" to="/colophon"><span>Colophon</span></router-link>
      <router-link v-if="$route.name != 'Tetatet'" :class="active('tetatet')" to="/tetatet"><span>tetatet</span></router-link>
      <router-link v-on:click.native="top(issue.uid)" v-for="issue in issues" :to="{ path: '/' + issue.uid }"><span :class="active(issue.uid)">{{issue.title}}</span></router-link>
    </div>
  </keep-alive>
</template>

<script>
  import _ from 'underscore'

  export default {
    name: 'Menu',
    data () {
      return { 
        menuVisible: false,
      }
    },
    computed: {
      apidata () {
        return this.$store.state.apidata
      },
      issues () {
        return _.values(this.apidata['1-issues'])
      }
    },
    methods: {
      active: function(name) {
        const uid = window.location.pathname.substr(1)
        if(name == uid || uid.match(name)) {
            return "active"
        }
      },
      top: function (name) {
        const uid = window.location.pathname.substr(1)
        this.$store.state.menuClick = !this.$store.state.menuClick
        if(name == uid != uid.match(name) && this.$route.name === "Issue") {
            window.scroll(0,0)
        } else if (uid.match(name)) {
          this.$store.state.previousRoute = 'issueInner'
        }
      }
    }
  }
</script>
  
<style lang="less">
  @import "../../styles/global.less";
  .menu {
    margin: 0 auto;
    max-width: 1720px;
    padding: @mp-a @mp-b @mp-a @mp-b;
    letter-spacing: .8px;
    cursor: default;

    margin-top: auto;
    z-index: 10000000;
    display: block;
    position: relative;
    opacity: 0;
    .fs-s;
    .active {
      text-decoration: underline;
      align-self: flex-start;
    }
    &_show {
      opacity: 1;
    }
    &_issue {
      padding-left: @mp-c;
    }
    a:not(:last-of-type):after {
      content: ", "
    }
    a:nth-last-child(2):after {
      content: " or ";
    }
  }

</style>





// WEBPACK FOOTER //
// src/components/library/menu.vue